import { render } from "./UserTablePlatform.vue?vue&type=template&id=57d94496&scoped=true&ts=true"
import script from "./UserTablePlatform.vue?vue&type=script&lang=ts"
export * from "./UserTablePlatform.vue?vue&type=script&lang=ts"

import "./UserTablePlatform.vue?vue&type=style&index=0&id=57d94496&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d94496"]])

export default __exports__